export default "__VITE_ASSET__317232e2__$_?react__"